import {
  Container,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Stack,
} from "@mui/joy";
import { PatternFormat } from "react-number-format";
import HeaderBackButton from "../components/HeaderBackButton";
import react from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Message } from "@mui/icons-material";

export default function Security() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const userInfos = useSelector((state) => state.useInfos);
  const [values, setValues] = react.useState({
    passcode: "",
    Message: "Enter your 4 digit pin code to proceed.",
    color: "warning",
  });

  const { passcode } = userInfos;

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    if (event.target.value === passcode) {
      setValues({ ...values, Message: "Pin Code Verified", color: "success" });
      navigate("/confirm", {
        state: state,
      });
    } else {
      setValues({ ...values, Message: "Invalid Pin Code", color: "danger" });
    }
  };

  return (
    <>
      <HeaderBackButton title={"Security"} />
      <Container maxWidth="sm">
        <form>
          <Stack spacing={2}>
            <FormControl size="lg" color={values.color} required>
              <FormLabel>Pincode</FormLabel>
              <PatternFormat
                name="passcode"
                label="Set Transaction Pin"
                onChange={handleChange}
                required
                value={values.passcode}
                minLength={4}
                maxLength={4}
                customInput={Input}
                placeholder="****"
                format="####"
                mask="*"
              />
              <FormHelperText>
                {values.Message}
              </FormHelperText>
            </FormControl>
          </Stack>
        </form>
      </Container>
    </>
  );
}
